import axiosInstance from "utils/axios";

/**
 * Gets the list of dynamic columns for an entity type
 * @param {number} entityTypeCode 
 * @returns {Promise<Object>}
 */
export const getEntityColumns = async (entityTypeCode) => {
  try {
    const response = await axiosInstance.get(`/api/EntityDynamicField/Columns/${entityTypeCode}`);
    const responseData = response.data;

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      let columns = [];
      if (typeof responseData.data === "string") {
        try {
          columns = JSON.parse(responseData.data);
        } catch (e) {
          console.error("Error parsing columns data:", e);
        }
      } else if (Array.isArray(responseData.data)) {
        columns = responseData.data;
      }
      return { success: true, data: columns, message: responseData.message };
    }
    throw new Error(responseData.message || "Failed to fetch columns");
  } catch (error) {
    console.error("Error fetching columns:", error);
    return {
      success: false,
      error: error.message || "Failed to fetch columns",
      data: [],
    };
  }
};
